import { useEffect, useState } from 'react';
import { HidroLayerComponent } from './layerComponent';
import { HidroLayerGroup } from './layers';

interface Props {
  hidroLayers: HidroLayerGroup;
  maxWidth?: string | number;
  maxHeight?: string | number;
}

export const HidroLayersComponent: React.FC<Props> = (data) => {
  const { hidroLayers } = data;
  const [state, setState] = useState(false);

  useEffect(() => {
    const listenerId = hidroLayers.addListener(() => setState(!state));
    return () => hidroLayers.removeListener(listenerId);

  }, [hidroLayers, state]);

  return <div style={{
    flex: 1,
    display: "flex",
    overflowY: "auto",
    flexDirection: "column",
    maxWidth: data.maxWidth,
    maxHeight: data.maxHeight,
  }}>
    {hidroLayers.layers.map((layer, index) => {
      return <HidroLayerComponent
        key={index}
        hidroLayer={layer}
        maxWidth={data.maxWidth}
      />;
    })}
  </div>;
};
